"use strict";
exports.__esModule = true;
exports.SLC_AUTOPAY_SETUP_CONTENT = void 0;
exports.SLC_AUTOPAY_SETUP_CONTENT = {
    HEADER: 'Should Flex pay your rent automatically each month?',
    SUB_HEADER: 'Choose who initiates your rent payments each month.',
    AUTOPAY_ON: {
        TITLE: 'Rent autopay on',
        CONTENT: 'We’ll process your rent automatically and help ensure your bills are paid on time. Best fit for those who value convenience.'
    },
    AUTOPAY_OFF: {
        TITLE: 'Rent autopay off',
        CONTENT: 'You’ll need to manually initiate your rent payment for greater control over payment timing. Best fit for those who prefer a more hands-on approach.'
    },
    CTA: 'Continue'
};
